// React Imports
import * as React from 'react';
import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';

// App Imports

import {
    DataGrid,
    GridToolbarColumnsButton,
    GridToolbarContainer,
    GridToolbarDensitySelector, GridToolbarExport,
    GridToolbarFilterButton
} from "@mui/x-data-grid";
import CustomFooter from "../../CommonComponents/GridCustomFooter";
import {getDataPointValueFilterByDataPointId} from "../DataPointClient";
import {changeDataPoint} from "../dataPointSlice";
import {Stack} from "@mui/material";
import Typography from "@mui/material/Typography";


// Main Function
export default function DataPointValueFilterListDrawer({fetchDataPointValueFilters}) {


    // ****************** BEGIN STATES ****************************

    const [dataPointValueFilters, setDataPointValueFilters] = useState([]);

    // ****************** END STATES ****************************


    // ****************** BEGIN STORE ****************************

    const dispatchDrawerCrudSnackbarSlc = useDispatch() ;
    const dispatchDrawerDataPointValueFilter = useDispatch() ;
    const selectorDataPointId = useSelector((state) => state.dataPointSlc.value.cdpvfListId);
    const selectorCdpvfDrawerState = useSelector((state) => state.dataPointSlc.value.cdpvfListDrawerState);
    const displayId = useSelector((state) => state.dataPointSlc.value.id);
    const displayName = useSelector((state) => state.dataPointSlc.value.name);

    // ********************** END STORE ********************************


    // ****************** END STORE ****************************


    // ****************** BEGIN REGISTER ****************************

    const dispatchData = useDispatch();

    // ****************** BEGIN FETCH ****************************

    const fetchDataPointValueFilterList = () =>
        getDataPointValueFilterByDataPointId(selectorDataPointId)
            .then(data => {
                console.log("this as my response");
                console.log(data);
                setDataPointValueFilters(data);
            });


    useEffect(() => {
        fetchDataPointValueFilterList();
    }, [ useSelector((state) => state.dataPointSlc.value.cdpvfListDrawerState)===true]);

    // ****************** END FETCH ****************************


    const renderDataPointValueFilters = dataPointValueFilters => {
        if (dataPointValueFilters.length <= 0) {
            return "No Data";
        }}


    // ****************** BEGIN CRUD ***********************************

    // ****************** END CRUD ***********************************

    function closeDataPointValueFilterListDrawer() {
        dispatchData(changeDataPoint({cdpvfListId: 0, cdpvfListDrawerState: false}));
    };


    // ****************** BEGIN DRILLDOWN ****************************


    // ****************** END DRILLDOWN ****************************


    // ****************** BEGIN TOOLBAR ****************************

    function CustomToolbar() {
        return (

            <GridToolbarContainer>
                <Box sx= {{
                    flexGrow: 1}}>
                    <GridToolbarColumnsButton />
                    <GridToolbarFilterButton sx={{mr: 3}} />
                    <GridToolbarDensitySelector />

                </Box>
                <Box sx= {{
                    flexGrow: 1}}>
                </Box>
                <Box sx= {{
                    flexGrow: 1,
                    display: { xs: 'none', md: 'flex' },
                    alignContent: 'flex-end',
                    justifyContent: 'flex-end',
                    ml:30
                }}>
                    <GridToolbarExport  />
                </Box>
            </GridToolbarContainer>
        );
    }

// ********************END TOOLBAR ********************************


    // ****************** BEGIN COLUMNS ****************************

    const columns = fetchDataPointValueFilters => [

        {    field: 'id',
            headerName: 'ID',
            sortable: true,
            width: 80,
        },
        {    field: 'dataSet',
            headerName: 'Data Set',
            sortable: true,
            width: 100,
        },
        {    field: 'contractType',
            headerName: 'Type',
            sortable: true,
            width: 130,
        },
        {    field: 'contractCategory',
            headerName: 'Category',
            sortable: true,
            width: 250,
        },
        {    field: 'contractName',
            headerName: 'Contract',
            sortable: true,
            width: 300,
        },
        {    field: 'sectionName',
            headerName: 'Section',
            sortable: true,
            width:500,
        },
        {    field: 'sectionOrdinalNumber',
            headerName: 'Order',
            sortable: true,
            width: 80,
        },
        {    field: 'dataPointName',
            headerName: 'Data Point',
            sortable: true,
            width: 200,
        },

    ];

    // ****************** END COLUMNS ****************************


    // ****************** BEGIN RETURN ****************************

    return (
        <div>
            <Drawer
                PaperProps={{
                    sx: { width: 1700 },
                }}
                anchor='right'
                // open={true}
                open={selectorCdpvfDrawerState}
                initialState={{open: false}}
                onClose={closeDataPointValueFilterListDrawer}
            >
                <Box style={{cursor:'pointer'}} sx= {{pl: 2}}>
                <h1 onClick={() => closeDataPointValueFilterListDrawer()}>Contract Data Point Value Filters</h1>
                    <Stack direction="row" spacing={1}>
                        <Typography component="span">id:</Typography>
                        <Typography component="span" fontWeight="bold">{displayId}</Typography>
                        <Box sx={{ ml: 6 }} /> {/* Adds extra spacing before 'name:' */}
                        <Typography component="span">name:</Typography>
                        <Typography component="span" fontWeight="bold">{displayName}</Typography>
                    </Stack>
                </Box>
                <DataGrid
                    experimentalFeatures={{ newEditingApi: true }}
                    initialState={{
                    }}
                    aria-label={"DataPointValueFilters"}
                    rows={dataPointValueFilters}
                    disableDensitySelector={true}
                    disableColumnSelector={true}
                    columns={columns(fetchDataPointValueFilterList)}
                    density={"compact"}
                    pageSize={20}
                    rowsPerPageOptions={[20]}
                    rowKey={dataPointValueFilter => dataPointValueFilter.id}
                    components={{
                        Toolbar: CustomToolbar,
                        Footer: CustomFooter,
                    }}
                />

            </Drawer>
        </div>
    );

    // ****************** END RETURN ****************************

}
